// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.web__container {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100vw;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #2d2d2d;
  overflow: scroll;
}
.web__container .title {
  position: absolute;
  top: 30px;
  left: 50px;
  font-size: 0.7em;
  font-weight: 300;
  letter-spacing: 5px;
  color: #bababa;
}
.web__container .fourOFour {
  font-size: 1em;
  font-weight: 300;
  letter-spacing: 5px;
  font-style: oblique;
  color: #0b0b0b;
  text-shadow: 1px 1px 5px rgba(200, 200, 200, 0.3);
}
.web__container .web__projectListContainer {
  position: absolute;
  top: 10vh;
  left: 0px;
  width: 100vw;
  letter-spacing: 5px;
  font-size: 0.7em;
  font-weight: 300;
}
.web__container .web__projectListContainer .web__projectList {
  display: inline-flex;
  vertical-align: middle;
  padding-bottom: 2px;
  cursor: pointer;
}
.web__container .web__projectListContainer .web__projectList:hover {
  opacity: 0.5;
}
.web__container .web__projectListContainer .web__projectList .web__badge {
  position: relative;
  top: 6px;
  border: 1px solid transparent;
  height: 10px;
  width: 10px;
  margin-right: 8px;
  border-radius: 5px;
}
.web__container .web__projectListContainer .web__projectListSpacer {
  display: inline-flex;
  padding: 0 20px;
  opacity: 0.15;
}
.web__container .web__projectListContainer .web__projectListSelected {
  font-weight: 400;
  text-shadow: 1px 1px 5px rgba(200, 200, 200, 0.5);
}
.web__container .web__projectListContainer .web__projectListSelected:hover {
  opacity: 1;
}
.web__container .web__projectListContainer .web__projectDesc {
  padding-top: calc(120px - 5vw);
  font-size: 0.8em;
  font-weight: 300;
  letter-spacing: 5px;
  font-style: oblique;
  color: rgba(186, 186, 186, 0.5);
}
.web__container .web__screenshots {
  text-align: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 10vw;
}
.web__container .web__screenshots .web__screenshot {
  width: 30vw;
  height: 30vw;
  max-width: 40vh;
  max-height: 40vh;
}
.web__container .web__screenshots .web__screenshot1 {
  z-index: 1;
  position: relative;
  top: 0vh;
  left: 10vh;
}
.web__container .web__screenshots .web__screenshot2 {
  z-index: 2;
  position: relative;
  top: 5vh;
  left: 0vh;
}
.web__container .web__screenshots .web__screenshot3 {
  z-index: 3;
  position: relative;
  top: 10vh;
  left: -10vh;
}
@media only screen and (max-width: 670px) {
  .web__container .web__projectListContainer {
    top: 80px;
    font-size: 0.5em;
    line-height: 25px;
  }
  .web__container .web__projectListContainer .web__projectListSpacer {
    display: none;
  }
  .web__container .web__projectListContainer .web__projectList .web__badge {
    top: 7px;
    margin-left: 20px;
  }
  .web__container .web__screenshots .web__screenshot {
    height: 75vw;
    max-height: 40vh;
  }
  .web__container .web__screenshots .web__screenshot1 {
    top: 0vh;
    left: 5vh;
  }
  .web__container .web__screenshots .web__screenshot2 {
    top: 5vh;
    left: 0vh;
  }
  .web__container .web__screenshots .web__screenshot3 {
    top: 10vh;
    left: -5vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Web/Web.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,gBAAA;AACJ;AAbA;EAeQ,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AACR;AAtBA;EAyBQ,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,iDAAA;AAAR;AA9BA;EAkCQ,kBAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AADR;AAvCA;EA2CY,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AADZ;AAEY;EACI,YAAA;AAAhB;AAhDA;EAmDgB,kBAAA;EACA,QAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAAhB;AAzDA;EA8DY,oBAAA;EACA,eAAA;EACA,aAAA;AAFZ;AA9DA;EAoEY,gBAAA;EACA,iDAAA;AAHZ;AAIY;EACI,UAAA;AAFhB;AArEA;EA4EY,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,+BAAA;AAJZ;AA7EA;EAsFQ,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AANR;AApFA;EA6FY,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AANZ;AA1FA;EAmGY,UAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AANZ;AAhGA;EAyGY,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AANZ;AAtGA;EA+GY,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AANZ;AAWA;EACI;IAEQ,SAAA;IACA,gBAAA;IACA,iBAAA;EAVV;EAME;IAMY,aAAA;EATd;EAGE;IAUgB,QAAA;IACA,iBAAA;EAVlB;EADE;IAiBY,YAAA;IACA,gBAAA;EAbd;EALE;IAqBY,QAAA;IACA,SAAA;EAbd;EATE;IAyBY,QAAA;IACA,SAAA;EAbd;EAbE;IA6BY,SAAA;IACA,UAAA;EAbd;AACF","sourcesContent":[".web__container {\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(45,45,45,1);\n    overflow: scroll;\n\n    .title { \n        position: absolute;\n        top: 30px;\n        left: 50px;\n        font-size: .7em;\n        font-weight: 300;\n        letter-spacing: 5px;\n        color: rgba(186,186,186,1);\n    }\n\n    .fourOFour { \n        font-size: 1em;\n        font-weight: 300;\n        letter-spacing: 5px;\n        font-style: oblique;\n        color: rgba(11,11,11,1);\n        text-shadow: 1px 1px 5px rgba(200,200,200,.3);\n    }\n\n    .web__projectListContainer{\n        position: absolute;\n        top: 10vh;\n        left: 0px;\n        width: 100vw;\n        letter-spacing: 5px;\n        font-size: .7em;\n        font-weight: 300;\n\n        .web__projectList {\n            display: inline-flex;\n            vertical-align: middle;\n            padding-bottom: 2px;\n            cursor: pointer;\n            &:hover {\n                opacity: .5;\n            }\n            .web__badge { \n                position: relative;\n                top: 6px;\n                border: 1px solid transparent;\n                height: 10px;\n                width: 10px;\n                margin-right: 8px;\n                border-radius: 5px;\n            }\n        }\n\n        .web__projectListSpacer{\n            display: inline-flex;\n            padding: 0 20px;\n            opacity: .15;\n        }\n\n        .web__projectListSelected {\n            font-weight: 400;\n            text-shadow: 1px 1px 5px rgba(200,200,200,.5);\n            &:hover {\n                opacity: 1;\n            }\n        }\n\n        .web__projectDesc {\n            padding-top: calc(120px - 5vw);\n            font-size: .8em;\n            font-weight: 300;\n            letter-spacing: 5px;\n            font-style: oblique;\n            color: rgba(186,186,186,.5);\n        }\n    }\n\n    .web__screenshots {\n        text-align: center;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        margin-bottom: 10vw;\n\n        .web__screenshot {\n            width: 30vw;\n            height: 30vw;\n            max-width: 40vh;\n            max-height: 40vh;\n        }\n        .web__screenshot1 {\n            z-index: 1;\n            position: relative;\n            top: 0vh;\n            left: 10vh;\n        }\n        .web__screenshot2 {\n            z-index: 2;\n            position: relative;\n            top: 5vh;\n            left: 0vh;\n        }\n        .web__screenshot3 {\n            z-index: 3;\n            position: relative;\n            top: 10vh;\n            left: -10vh;\n        }\n    }\n}\n\n@media only screen and (max-width: 670px) {\n    .web__container {\n        .web__projectListContainer {\n            top: 80px;\n            font-size: .5em; \n            line-height: 25px;\n            .web__projectListSpacer{\n                display: none;\n            }\n            .web__projectList {\n                .web__badge { \n                    top: 7px;\n                    margin-left: 20px;\n                }\n            }\n        }\n        .web__screenshots {\n            .web__screenshot {\n                height: 75vw;\n                max-height: 40vh;\n            }\n            .web__screenshot1 {\n                top: 0vh;\n                left: 5vh;\n            }\n            .web__screenshot2 {\n                top: 5vh;\n                left: 0vh;\n            }\n            .web__screenshot3 {\n                top: 10vh;\n                left: -5vh;\n            }\n        }\n    }\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
